export const BUSINESS_LENDING_FEATURE_FLAG =
  'gate_temp_merchant_business_lending_banner'

export const BUSINESS_LENDING_SIDEBAR_FEATURE_FLAG =
  'gate_merchant_business_lending'

export const BUSINESS_LENDING_BANNER_STATUS = {
  INTRO: 'intro',
  IN_PROGRESS: 'in_progress',
  READY: 'ready',
}

export const MERCHANT_LOAN_APPLICATION_STATUS = {
  ACTIVE: 'ACTIVE',
  CANCELLED: 'CANCELLED',
  REJECTED: 'REJECTED',
}

export const MERCHANT_LOAN_APPLICATION_STEP = {
  ACTIVE: 'ACTIVE',
}
